module.exports = __webpack_public_path__ + "static/media/img4.456cc721.jpg";